export default __webpack_public_path__ + "static/media/icon-calculator.be0e39dd.png";